// | ------------------------------------------------------------------------
// | Scroll LInks
// | ------------------------------------------------------------------------

const scrollLinks = document.querySelectorAll(".scroll-link");

for (const scrollLink of scrollLinks) {
  scrollLink.addEventListener("click", scrollLinkHandler);
}

function scrollLinkHandler(e) {
  e.preventDefault();

  const href = this.getAttribute("href");

  // get the correct offset
  const getOffsetTop = (element) => {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  };

  // find the target element
  const scrollTarget = document.querySelector(href);

  // the elements offset value
  const offsetTop = getOffsetTop(scrollTarget);

  // current header height value
  const x = getComputedStyle(document.documentElement).getPropertyValue(
    "--header-height"
  );

  // convert to integer
  const headerHeight = parseInt(x);

  // minus header height from the offset
  const totalOffset = offsetTop - headerHeight;

  if (window.matchMedia("(max-width: 768px)").matches) {
    // scroll to element
    scroll({
      top: offsetTop,
      behavior: "smooth",
    });
  } else {
    // scroll to element accounting for header height
    scroll({
      top: totalOffset,
      behavior: "smooth",
    });
  }
}

/*
const galleryLinks = document.querySelectorAll(". gallery-link");

for (const galleryLink of galleryLinks) {
  galleryLink.addEventListener("click", galleryLinkHandler);
}

function galleryLinkHandler(e) {
  e.preventDefault();

  const href = this.getAttribute("href");

  // get the correct offset
  const getOffsetTop = (element) => {
    let offsetTop = 0;
    while (element) {
      offsetTop += element.offsetTop;
      element = element.offsetParent;
    }
    return offsetTop;
  };

  // find the target element
  const scrollTarget = document.querySelector(href);

  // the elements offset value
  const offsetTop = getOffsetTop(scrollTarget);

  // current header height value
  const x = getComputedStyle(document.documentElement).getPropertyValue(
    "--header-height"
  );

  // convert to integer
  const headerHeight = parseInt(x);

  // minus header height from the offset
  const totalOffset = offsetTop - headerHeight;

  const galleryNavSelect = 100;

  const galleryNavOffset = offsetTop - galleryNavSelect;

  if (window.matchMedia("(max-width: 768px)").matches) {
    // scroll to element
    scroll({
      top: galleryNavOffset,
      behavior: "smooth",
    });
  } else {
    // scroll to element accounting for header height
    scroll({
      top: totalOffset,
      behavior: "smooth",
    });
  }
}
*/
